import React, { Component } from 'react'
import ScrollSVG from './scroll-svg'
import classnames from 'classnames'

class HeroTooltip extends Component {
  constructor(props) {
    super(props) 
    this.state = {
      iconX: 0,
      iconY: 0
    }
  }

  componentDidUpdate(prevProps) {
    const {
      icon: prevIcon
    } = prevProps 
    const {
      icon: nextIcon
    } = this.props 

    if (prevIcon !== nextIcon) {
      if (nextIcon) {
        this.addMouseMoveListener()
      } else {
        this.removeMouseMoveListener()
      }
    }
  }

  addMouseMoveListener() {
    window.addEventListener('mousemove', this.handleMouseMove)
  }

  removeMouseMoveListener() {
    window.removeEventListener('mousemove', this.handleMouseMove)
  }

  handleMouseMove = e => {
    const offsetY = 0
    const padding = 16

    this.setState({
      iconX: e.pageX + padding,
      iconY: (e.pageY - offsetY) + padding
    })
  }

  render() {
    const { icon } = this.props
    const { iconX, iconY } = this.state
    return (
      <div style={{
        transform: `translate(${iconX}px, ${iconY}px)`
      }} className={classnames({'hero__tooltip--active': icon && (iconX && iconY) }, 'hero__tooltip')}>
        <ScrollSVG />
      </div>
    )
  }
}

export default HeroTooltip



// WEBPACK FOOTER //
// ./src/components/hero/hero-tooltip.js